var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2 2 26 26",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.5 27.5L5.5 2.5 18.8 2.5 24.5 8.2 24.5 27.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#788b9c",
    d: "M18.6,3L24,8.4V27H6V3H18.6 M19,2H5v26h20V8L19,2L19,2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.5 8.5L18.5 2.5 18.8 2.5 24.5 8.2 24.5 8.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#788b9c",
    d: "M19,3.4L23.6,8H19V3.4 M19,2h-1v7h7V8L19,2L19,2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#b272db",
    d: "M18.9 20.8L18.1 20.2 19.9 17.5 18.1 14.8 18.9 14.2 21.1 17.5zM11.1 20.8L8.9 17.5 11.1 14.2 11.9 14.8 10.1 17.5 11.9 20.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#b272db",
    d: "M9.8 17H20.200000000000003V18H9.8z",
    transform: "rotate(-73.316 15 17.5)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.fc8657e2.svg";
export { ForwardRef as ReactComponent };